import React from 'react';
import { Table, Typography } from 'antd';
import { ShrinkOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const SparesExpandView = (props) => {
  const {
    showModal,
    setIsKitModalVisible,
    handlePublish,
    handleDownloadExcelSheet,
    setShowExpandModal,
    columns,
    sparesList,
    isSparesListLoading,
    sparesDataCount,
    current,
    setCurrent,
    setCurrentPagesize,
    selectedProject,
    // pageSize,
    // pageNumber,
    equipmentType,
    assignedToSerialNumberValue,
    equipmentSubCategory,
    sapKitNo,
    sapNumber,
    description,
    unit,
    safetyStock,
    cost,
    onFetchSparesDashBoardList,
    setOpenUploadModal,
    handleDownloadTemplate,
  } = props;

  return (
    <div className="billingGrid-expand">
      <div className="h-100 overflow-y-hidden overflow-x-hidden">
        <div className="flex-auto">
          <div className="d-flex mb-3 align-items-center tab-content-title">
            <Title
              className="mb-0"
              level={4}
            >
              List of Spares
            </Title>
            <div className="new-project-team">
              <Text
                onClick={showModal}
                className="ps-3 add-new-team"
              >
                <span className="icon-22">
                  <svg>
                    <use xlinkHref="#add" />
                  </svg>
                </span>
                Add individual spare
              </Text>
              <Text
                onClick={() => setIsKitModalVisible(true)}
                className="ps-3 add-new-team"
              >
                <span className="icon-22">
                  <svg>
                    <use xlinkHref="#add" />
                  </svg>
                </span>
                Add Spare Kit
              </Text>
              <Text
                onClick={handlePublish}
                className="ps-3 add-new-team"
              >
                <span className="icon-22">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="5"
                      y="2"
                      width="14"
                      height="20"
                      rx="2"
                      ry="2"
                    ></rect>
                    <line
                      x1="12"
                      y1="18"
                      x2="12"
                      y2="18"
                    ></line>
                  </svg>
                </span>
                Publish in App
              </Text>
              <Text
                onClick={handleDownloadExcelSheet}
                className="ps-3 add-new-team"
              >
                <span className="icon-22">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    viewBox="0 0 1024 1024"
                  >
                    <path
                      fill="currentColor"
                      d="M880 912H144c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32h360c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8H184v656h656V520c0-4.4 3.6-8 8-8h56c4.4 0 8 3.6 8 8v360c0 17.7-14.3 32-32 32M770.87 199.131l-52.2-52.2c-4.7-4.7-1.9-12.8 4.7-13.6l179.4-21c5.1-.6 9.5 3.7 8.9 8.9l-21 179.4c-.8 6.6-8.9 9.4-13.6 4.7l-52.4-52.4l-256.2 256.2c-3.1 3.1-8.2 3.1-11.3 0l-42.4-42.4c-3.1-3.1-3.1-8.2 0-11.3z"
                    />
                  </svg>
                </span>
                Export to Excel
              </Text>
              {
                <Text
                  onClick={handleDownloadTemplate}
                  className="ps-3 add-new-team"
                >
                  <span className="icon-22">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 3v18M5 12l7 7 7-7"></path>
                    </svg>
                  </span>
                  Download template
                </Text>
              }

              <Text
                onClick={() => {
                  setOpenUploadModal(true);
                }}
                className="ps-3 add-new-team"
              >
                <span className="icon-22">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    transform="rotate(180)"
                  >
                    <path d="M12 3v18M5 12l7 7 7-7"></path>
                  </svg>
                </span>
                Upload
              </Text>
              <Text
                onClick={() => setShowExpandModal(false)}
                className="ps-3 add-new-team"
              >
                <span className="icon-22">
                  <ShrinkOutlined />
                </span>
                Minimize
              </Text>
            </div>
          </div>
          <div className="custom-line" />
        </div>
        <div className="spareOrderDetails">
          <Table
            columns={columns}
            dataSource={sparesList}
            className="h-100 pipeline-table spares_dashtable table-action-column"
            scroll={{
              y: sparesDataCount > 0 ? 'calc(100vh - 330px)' : null,
              x: 2295,
            }}
            loading={isSparesListLoading}
            pagination={
              sparesDataCount > 0
                ? {
                    position: ['bottomRight'],
                    className: 'fixed-pagination',
                    showSizeChanger: true,
                    total: sparesDataCount,
                    defaultPageSize: 10,
                    defaultCurrent: 1,
                    current: current,

                    onChange: async (pageNumber, pageSize) => {
                      setCurrent(pageNumber);
                      setCurrentPagesize(pageSize);
                      let obj = {
                        projectId: selectedProject.id,
                        pageSize: pageSize,
                        pageNumber: pageNumber,
                        equipmentType: equipmentType,
                        assignedToSerialNumber: assignedToSerialNumberValue,
                        subCategory: equipmentSubCategory,
                        sapKitNo: sapKitNo,
                        sapNumber: sapNumber,
                        description: description,
                        unit: unit,
                        safetyStock: safetyStock,
                        cost: cost,
                      };
                      await onFetchSparesDashBoardList(obj);
                    },
                  }
                : false
            }
            onChange={(pagination, filters, sorter) => {
              if (sorter.columnKey && sorter.order) {
                const sortOrder = sorter.order === 'descend' ? 'DESC' : 'ASC';
                const sortParam = {
                  projectId: selectedProject.id,
                  [sorter.columnKey]: [sorter.columnKey, sortOrder],
                };
                onFetchSparesDashBoardList(sortParam);
              }
            }}
            style={sparesDataCount > 0 ? {} : { overflowY: 'hidden' }}
          />
        </div>
      </div>
    </div>
  );
};

export default SparesExpandView;